import {initMap, initMapCenter, initMapMarkerAnimation} from './mapStyle.jsx'

import $ from 'jquery'

export default function ContactMap() {
    function initContactMap() {
        let pm = $('#page-map');
        let contactMap = initMap('page-map')
        let bounds = new google.maps.LatLngBounds();
        //let pos = new google.maps.LatLng(44.4170504, 8.7251712)
        let pos = new google.maps.LatLng(pm.data('lat'), pm.data('lng'))

        bounds.extend(pos)
        bounds.extend(pos)
        let marker = new google.maps.Marker({
            position: pos,
            map: contactMap
        })
        initMapMarkerAnimation(marker)
        initMapCenter(contactMap, bounds)
        contactMap.setZoom(3)
    }

    let int = setInterval(() => {
        if (!googleMapsLoaded) return
        clearInterval(int)
        initContactMap()
    }, 300);
}



// WEBPACK FOOTER //
// ./app/Resources/assets/js/front/contactmap.jsx